import React, { FC, SyntheticEvent, useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { QuestionSearchResultDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { useSearchQuestions } from "@api";
import { useUserStore } from "@store/user";
import { Autocomplete, TextField } from "@components/base";

interface SearchQuestions {
  onSelectQuestion: (questionCode: string) => void;
}

const SearchQuestions: FC<SearchQuestions> = ({ onSelectQuestion }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { searchQuestionsAsync, searchResults } = useSearchQuestions(user);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (
    event: SyntheticEvent<Element, Event>,
    value: QuestionSearchResultDto | null,
  ): void => {
    if (value) {
      onSelectQuestion(value.code);
      setSearchTerm("");
    }
  };

  const debounceSearchQuestions = useCallback(
    debounce(searchQuestionsAsync, 750),
    [],
  );

  useEffect(() => {
    if (searchTerm.length > 2) {
      debounceSearchQuestions(searchTerm);
    }
  }, [searchTerm, debounceSearchQuestions]);

  return (
    <Autocomplete
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder={t("admin.emissionFactors.autocompletePlaceholder")}
        />
      )}
      options={searchResults || []}
      getOptionLabel={(option) => option.name}
      onChange={handleChange}
      noOptionsText={t("admin.emissionFactors.autocompleteNoOptions")}
      inputValue={searchTerm}
    />
  );
};

export default SearchQuestions;
